<style lang="css">
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead .con-td-check{
  margin-top: 45px;
  justify-content: center;
  display: flex;
}
.vs-con-table td.td-check{
  display: flex;
  margin-top: 22px;
  justify-content: center;
}
.vs-tooltip{
  white-space: nowrap;
}
.vs-con-table .vs-table--header .vs-table--search{
  padding: 10px 0;
}
.text_gray{
  color: #B9B9C3;
}
.imgTitle{
  width: 34px;
  height: 35px;
  border-radius: 50%;
}
.color-text {
  color: #626262 !important
}
.vs-con-thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  z-index: 5;
  position: fixed;
}
.vs-table--thead th{
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}
.name_user{
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 50%;
}
.actives {
  border-radius: 3px;
  border: 1px solid #277DF6;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 28px;
  min-width: 220px;
  margin-bottom: 8px;
  margin-right: 10px;
  color: rgb(91, 165, 214)
}
.checkbox-min{
  margin-left: 0 !important;
}
.blue-classification{
  background-color: rgba(39, 125, 246,1) !important;
}
.yellow-classification{
  background-color: #f3cc60 !important;
}
.red-classification{
  background-color: #e60004 !important;
}
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.reportrange-text{
  border-radius: 10px;
}
.daterangepicker {
  border-left: none !important;
}
.title-size {
  font-size: 14px;
  font-weight: bold;
}
.text-size {
  font-size: 12px !important;
}
.checkbox-min {
  font-size: 12px;
}
.article-news {
  border-radius: 3px;
  border: 1px solid #ccc;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 24px;
  min-width: 150px;
  margin-right: 10px;
}
.article-news:hover {
  border-radius: 3px;
  border: 1px solid #277DF6;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 24px;
  min-width: 150px;
  margin-right: 10px;
  color: rgb(91, 165, 214)
}
.classification-f {
  position: absolute;
  top: 5px;
  margin-left: 6%;
}
@media only screen and (max-height:1080px){
  .risize-table .vs-con-table .vs-con-tbody{
    z-index: 0;
    overflow-x: hidden !important;
    min-height: 620px;
  }
}
@media only screen and (min-height:1080px){
  .risize-table .vs-con-table .vs-con-tbody{
    z-index: 0;
    overflow-x: hidden !important;
    min-height: 750px;
  }
}
.text-news{
  height: 34px;
  font-size: 12px !important;
  word-wrap: break-word;
}
.title-news{
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
}
.hideText{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
  color: #626262;
}
.icon_shade_form{
  transform: scale(1.25);
}
.shade{
  color: white;
  font-size: 11px;
  border-radius: 5px;
  width: 85px;
  height: 15px;
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
}
.source-profile{
  height: 19px;
  display: flex;
  color: #626262;
}
.text-form-time{
  color: #5E5873;
  font-size: 12px;
}
.text-source{
  font-size: 13px;
  font-weight: 600;
}
.text-time{
  font-size: 11px;
  color: rgb(191, 191, 200);
}
.text-news{
  color: #626262;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2 !important; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.text-color{
  color: #B7B7B7;
}
.content-from{
  text-align: justify !important
}
.content-mid{
  display: flex;
  flex-direction: column
}
.shade-content{
  align-items: center;
  margin-top: 10px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
}
.percent-shade{
  font-size: 12px;
  margin-left: -47%;
}
.title-form{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1 !important;
  width: 70%;
  -webkit-box-orient: vertical;
  font-size: 16px;
}
.text-content-form{
  font-size: 14px;
  line-height: 25px;
}
.text-icon{
  font-size: 14px;
}
.reaction-card {
  border-radius: 0.5rem;
  margin: -15px 0px 10px;
  background-color: rgb(236, 242, 249)
}
.classification-fb {
  position: absolute;
  top: 9rem;
  right: 1rem;
  width: 20rem;
  left: 50%;
  z-index: 999;
  background-color: rgba(236, 242, 249);
}
.classification-detail {
  position: absolute;
  top: 9rem;
  right: 1rem;
  width: 20rem;
  left: 50%;
  z-index: 999;
  background-color: rgba(236, 242, 249);
}
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
.color_Pos{
  color: #007AFE;
}
.color_Nega{
  color: #F12B2C;
}
.color_Neu{
  color: #FEC400;
}
@media only screen and (min-height:1080px) {
  .content-resize {
    height: 900px;
  }
  .size-content {
    height: 840px !important;
  }
}
@media only screen and (max-height:1080px) {
  .size-content {
    height: 673px !important;
  }
}
</style>
<template>
  <div id="demo-basic-card" class="social">
    <div class="card-view-new vx-row pr-0 pb-0 content-resize">
      <div class="md:w-2/3 w-full vx-col m-0">
        <div class="vx-row">
          <div class="vx-col md:w-5/12 w-full">
          <div class="mt-2 vx-col p-4">
            <div class="vx-col">
              <div class="text-topic" style="min-width:100px">
                <span class="title-size">{{$t('articleBookmark.project')}}/{{$t('articleBookmark.topics')}}:</span>
              </div>
              <div class="topic-selected">
                <v-select class="text-size md:w-4/5" v-model="topicSelected" :options ="optionalsTopic"  @input="findByTopicId" :dir="$vs.rtl ? 'rtl' : 'ltr'" style="min-width: 200px;"/>
              </div>
            </div>
          </div>
          <div class="mt-2 vx-col p-4">
            <div class="vx-col w-full">
              <span class="title-size">{{$t('title.time')}}</span>
            </div>
            <div class="vx-col w-full">
              <date-range-picker
                class="md:w-4/5 custom-time"
                ref="picker"
                :locale-data="{format: 'dd/mm/yyyy' }"
                :opens="'right'"
                @update="loadData"
                v-model="dateRange">
              </date-range-picker>
            </div>
          </div>
          <div class="mt-2 vx-col p-4">
            <div class="vx-col w-full">
              <span class="title-size">{{$t('title.shades')}}: </span>
              <div class="vx-row mt-2 ml-0 cursor-pointer hover:text-primary" style="font-size:12px"><vs-checkbox color="primary" v-model="checkBoxPositive"></vs-checkbox><span :class="{text_gray : !checkBoxPositive}">{{$t('title.positive')}}</span></div>
              <div class="vx-row mt-2 ml-0 cursor-pointer hover:text-danger" style="font-size:12px"><vs-checkbox color="danger" v-model="checkBoxNegative"></vs-checkbox><span :class="{text_gray : !checkBoxNegative}">{{$t('title.negative')}}</span></div>
              <div class="vx-row mt-2 ml-0 cursor-pointer hover:text-warning" style="font-size:12px"><vs-checkbox color="warning" v-model="checkBoxNeutral"></vs-checkbox><span :class="{text_gray : !checkBoxNeutral}">{{$t('title.neutral')}}</span></div>
            </div>
          </div>
            <div class="mt-2 vx-col p-4">
              <div class="vx-col w-full">
                <span class="title-size">{{$t('articleDetail.source')}}: </span>
              </div>
              <div class="vx-col w-full" style="height: 350px;overflow: hidden;overflow-y: inherit;">
                <div class="vx-col">
                  <div class="vx-row w-full mt-2 checkbox-min cursor-pointer"  v-if="getAll == true" >
                    <vs-checkbox v-model="checkBoxAllData"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxAllData}">{{$t('articleDetail.all')}} </span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="labelNews==true" @click="getAllNews">
                    <vs-checkbox  v-model="checkBoxAllNews" @click="getAllNews"></vs-checkbox> {{$t('articleDetail.all')}}
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="labelSocial==true" @click="getAllSocial">
                    <vs-checkbox  v-model="checkBoxAllSocial" @click="getAllSocial"></vs-checkbox> {{$t('articleDetail.all')}}
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min cursor-pointer"
                       v-if="showFacebookProfile == true">
                    <vs-checkbox v-model="checkBoxFacePost"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxFacePost}">{{$t('articleDetail.postFacebook')}} </span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="showFacebookComment == true">
                    <vs-checkbox v-model="checkBoxFaceComment"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxFaceComment}">{{$t('articleDetail.facebookComment')}}</span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="showNewsPost == true" >
                    <vs-checkbox v-model="checkBoxNews"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxNews}">{{$t('articleDetail.news')}}</span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="showYoutube == true" >
                    <vs-checkbox v-model="checkBoxYoutube"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxYoutube}">Youtube</span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="showTiktok == true" >
                    <vs-checkbox v-model="checkBoxTiktok"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxTiktok}">Tiktok</span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="showTwitter == true" >
                    <vs-checkbox v-model="checkBoxTwitter"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxTwitter}">Twitter</span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min cursor-pointer"
                       v-if="showIgPost == true">
                    <vs-checkbox v-model="checkBoxIgPost"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxIgPost}">{{$t('articleDetail.postIg')}} </span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="showForum == true" >
                    <vs-checkbox v-model="checkBoxForum"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxForum}">Forum</span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min"
                       v-if="showGoogle == true" >
                    <vs-checkbox v-model="checkBoxGoogle"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxGoogle}">Google</span>
                  </div>
                  <div class="vx-row w-full mt-2 checkbox-min" style="margin-right:10px" v-for="(source,indexSource) in sourceData" :key="indexSource" >
                    <vs-checkbox v-model="source.checkBoxOther"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!source.checkBoxOther}">{{source.name}}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full">
                <span class="title-size">{{$t('articleDetail.private')}}: </span>
              </div>
              <div class="vx-col w-full" >
                <div class="vx-col">
                  <div class="vx-row w-full mt-2 checkbox-min cursor-pointer"
                       v-if="showFacebookPrivate == true">
                    <vs-checkbox v-model="checkBoxPrivate"></vs-checkbox>
                    <span class="ml-2 mt-1" :class="{text_gray :!checkBoxPrivate}">{{$t('articleDetail.private')}}</span>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div style="vx-col md:w-7/12 w-full" class="risize-table">
          <template>
            <vs-table
              search
              :maxHeight="resizeContent"
              colspan
              v-model="selected"
              :data="rowDatas"
              :noDataText="this.$t('noData')"
              multiple>
              <template slot="header">
                <h3>
                </h3>
              </template>
              <template slot="thead">
                <vs-th >
                  <div class="vx-col w-full">
                    <div class="vx-row ml-0" style="display: flex;align-items: center;">
                      <div class="md:w-1/2 vx-col">
                        <span class="text-size"><span class="text-color mr-1">{{$t('articleDetail.result')}}:</span> <b style="color:rgba(var(--vs-primary),1);">{{ currentPage }} - {{ totalContent }}</b>/{{ totalElements }} {{$t('articleDetail.content')}}</span>
                      </div>
                      <div class="md:w-1/2 vx-col">
                        <v-select class="text-size" style="width: 160px;float: right;" v-model="sortSelected" :options="optionalSort"  @input="findSort"></v-select>
                      </div>
                    </div>
                    <hr class="mt-2 mb-2 opacity-50">
                    <div class="vx-row ml-0" style="display: flex;align-items: center;">
                      <div class="md:w-1/2 vx-col"><span>{{$t('articleBookmark.selectAll')}}</span></div>
                      <div class="md:w-1/2 vx-col" style="display: flex;justify-content: flex-end;">
                        <div class="flex cursor-pointer" style="justify-content: center;align-items: center;" @click="updateBookmarkMany">
                          <vx-tooltip
                            color="warning"
                            :text="$t('articleDetail.save')">
                            <feather-icon icon ="BookmarkIcon" style="vertical-align: bottom;width: 18px;color: #626262;"></feather-icon>
                          </vx-tooltip>
                        </div>
                        <div class="flex cursor-pointer ml-2" style="justify-content: center;align-items: center;" @click="confirmSpamMany">
                          <vx-tooltip
                            color="danger"
                            :text="this.$t('articleDetail.markSpam')">
                            <feather-icon icon ="Trash2Icon" style="vertical-align: bottom;width: 18px;"></feather-icon>
                          </vx-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" style="border-bottom: 1px solid #EBE9F1;">
                  <vs-td style="max-width: 0px">
                    <div class="w-full vx-col" @click="openItem(tr,indextr)">
                      <div class="vx-row">
                        <div class="vx-col w-full md:w-2/3 hideText">
                          <div class="vx-row ml-0">
                            <div class="pt-2" v-if="data[indextr].image !=null">
                              <img class="imgTitle" @error="imgError" :src="data[indextr].image" >
                            </div>
                            <div class="pt-2" v-else >
                              <img class="imgTitle"  src="@/assets/images/logo/no_image.png" >
                            </div>
                            <div class="vx-col" style="display: flex;flex-direction: column;">
                              <div class="vx-col mt-2">
                                <div v-if="isPrivate == false" class="source-profile ">
                                  <span v-if="data[indextr].source == 'page'" class="text-source">Facebook Page</span>
                                  <span v-if="data[indextr].source == 'profile'" class="text-source">Facebook Profile</span>
                                  <span v-if="data[indextr].source == 'group'" class="text-source">Facebook Group</span>
                                  <span v-if="data[indextr].beanType == 101 || data[indextr].beanType == 111" class="text-source">{{data[indextr].domainName}}</span>
                                  <span v-if="data[indextr].beanType == 106" class="text-source">Youtube</span>
                                  <span v-if="data[indextr].beanType == 113" class="text-source">Google</span>
                                  <span v-if="data[indextr].beanType == 116" class="text-source">Tiktok</span>
                                  <span v-if="data[indextr].beanType == 117" class="text-source">Tiktok</span>
                                  <span v-if="data[indextr].beanType == 118" class="text-source">Twitter</span>
                                  <span v-if="data[indextr].beanType == 119" class="text-source">Instagram</span>
                                  <span v-if="data[indextr].beanType == 120" class="text-source">Instagram</span>
                                </div>
                                <div v-if="isPrivate == true" class="source-profile" :title="data[indextr].sourceName">
                                  <span class="text-source hide-text-source">{{data[indextr].sourceName || " "}} </span>
                                </div>
                                <span class="text-time pt-2">{{$t('articleDetail.at')}}:{{data[indextr].publishDateForm}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="md:w-1/3" style="display: flex;justify-content: flex-end;align-content: flex-start;">
                          <div class="p-2 flex " style="justify-content: center;align-items: center;" @click="updateBookmark(data[indextr])" v-if="data[indextr].isBookmark == false">
                            <vx-tooltip
                              color="warning"
                              :text="$t('articleDetail.save')">
                              <feather-icon icon ="BookmarkIcon" style="vertical-align: bottom;width: 18px;color: #626262;"></feather-icon>
                            </vx-tooltip>
                          </div>
                          <div class="p-2 flex cursor-pointer" style="justify-content: center;align-items: center;color:rgba(var(--vs-warning),1);" @click="updateBookmark(data[indextr])" v-else>
                            <vx-tooltip
                              color="warning"
                              :text="$t('articleDetail.unSavedChanges')">
                              <feather-icon icon ="BookmarkIcon" style="vertical-align: bottom;width: 18px;"></feather-icon>
                            </vx-tooltip>
                          </div>
                          <vs-dropdown :title="$t('button.seeMore')" class="cursor-pointer" style="margin: 0px !important;">
                            <vs-button class="btn-drop" type="flat" icon="more_horiz"
                                       style="color: #626262 !important;"></vs-button>
                            <vs-dropdown-menu class="">
                              <vs-dropdown-item @mousemove="backgroundHover">
                                <div class="p-2 flex cursor-pointer" style="justify-content: center;align-items: center;" @click="confirmSpam(data[indextr])">
                                  <feather-icon icon ="Trash2Icon" style="vertical-align: bottom;width: 18px;color: red"></feather-icon>
                                  <span class="ml-4 text-icon color-text text-spam">{{$t('articleDetail.markSpam')}}</span>
                                </div>
                              </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>
                      <div class="vx-col mt-2">
                        <span class="text-news">
                        <p v-html="data[indextr].displayFullContent"  :class="{'item-description text-sm text cursor-pointer  text-size' : data[indextr].beanType == 104 || data[indextr].beanType == 105, 'item-description text-sm text-news cursor-pointer text-size' : data[indextr].beanType == 101 || data[indextr].beanType == 106  || data[indextr].beanType == 111 || data[indextr].beanType == 113 || data[indextr].beanType == 116 || data[indextr].beanType == 117 || data[indextr].beanType == 118 || data[indextr].beanType == 119 || data[indextr].beanType == 120}">
                        </p>
                      </span>
                      </div>
                      <div @click="openPost(data[indextr])" class="vx-col mt-2 cursor-pointer card-preview" >
                        <div class="hideText">
                          <span style="font-weight: 600;font-size: 16px">{{data[indextr].title}}</span>
                        </div>
                        <span style="color: #626262;">{{data[indextr].domain}}</span>
                      </div>
                      <div class="w-full"  v-if="data[indextr].beanType ==104 || data[indextr].beanType == 105" style="margin-top: 5px;" >
                        <div class="vx-row" style="margin-top: 5px;">
                          <div class="md:w-1/2 vx-row ml-0">
                            <div class="pl-4" style="margin-top: 5px;">
                              <img :src="data[indextr].highlightReaction.icon" alt="" style="width:18px">
                            </div>
                            <div class="ml-1" style="display: flex;align-items: center; ;text-align:center">
                              <span class="text-size" style="margin-top: 2px;"><b style="color: #626262;">{{nFormatter(data[indextr].highlightReaction.value) || 0}}</b></span>
                              <div class="ml-1">
                                <span class="text-size text-color" style="color: #626262;">({{$t('articleBookmark.like')}}:{{data[indextr].highlightReaction.percent || 0}}%)</span>
                              </div>
                            </div>
                          </div>
                          <div class="md:w-1/2" style="display: flex;justify-content: flex-end;">
                            <span class="text-color"><b style="color: #626262;margin-left: 2px;padding-left: 2px;">{{nFormatter(data[indextr].comment)}}</b><span style="font-size: 12px"> {{$t('articleBookmark.comment')}}</span><b class="ml-2" style="color: #626262;margin-left: 2px;">{{nFormatter(data[indextr].share)}}</b><span style="font-size: 12px"> {{$t('articleBookmark.share')}}</span></span>
                          </div>
                        </div>
                      </div>
                      <div class="w-full" style="border-top: 1px solid #EBEBEB;margin-top: 5px">
                        <div v-if="data[indextr].percentPositive == data[indextr].percentNegative && data[indextr].percentNegative == data[indextr].percentNeurtal" class="vx-row" style="width: 80%">
                          <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;">
                            <feather-icon class="color_Pos" icon="SmileIcon" style="width: 15px;"></feather-icon>
                            <span class="ml-2"><b style="color: #626262;">{{ data[indextr].percentPositive || 0 }} %</b></span>
                          </div>
                          <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;" >
                            <feather-icon class="color_Nega" icon="FrownIcon" style="width: 15px;"></feather-icon>
                            <span class="ml-2"><b style="color: #626262;">{{ data[indextr].percentNegative || 0 }} %</b></span>
                          </div>
                          <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;">
                            <feather-icon class="color_Neu" icon="MehIcon" style="width: 15px;"></feather-icon>
                            <span class="ml-2"><b style="color: #626262;">{{ data[indextr].percentNeurtal || 0 }} %</b></span>
                          </div>
                        </div>
                        <div v-else class="vx-row" style="width: 80%">
                          <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;">
                            <feather-icon :class="{color_Pos : data[indextr].classification == 1}" icon="SmileIcon" style="width: 15px;"></feather-icon>
                            <span class="ml-2"><b style="color: #626262;">{{ data[indextr].percentPositive || 0 }} %</b></span>
                          </div>
                          <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;">
                            <feather-icon :class="{color_Nega : data[indextr].classification == -1}" icon="FrownIcon" style="width: 15px;"></feather-icon>
                            <span class="ml-2"><b style="color: #626262;">{{ data[indextr].percentNegative || 0 }} %</b></span>
                          </div>
                          <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;">
                            <feather-icon :class="{color_Neu : data[indextr].classification == 0}" icon="MehIcon" style="width: 15px;"></feather-icon>
                            <span class="ml-2"><b style="color: #626262;">{{ data[indextr].percentNeurtal || 0 }} %</b></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </template>
          <div class="vx-col w-full " style="margin-top: 5px;transform: scale(0.8);margin-left: 36px;">
            <vs-pagination
              :total ="totalPages"
              :max="maxPageNumbers"
              v-model="currentPage"
              :per-page="perPage"
              @change="onChangePage"
            ></vs-pagination>
          </div>
        </div>
        </div>
      </div>
      <div class="md:w-1/3 w-full" style="background-color: #F8F8F8">
        <div class="vx-col w-full">
          <div class="vx-row m-0 style-header-form" v-if="selectedContent" style="background-color: #FFFFFF">
            <div class="vx-col md:w-2/3 w-full shade-content ">
              <div class="hideText">
                <span>{{ formData.title }}</span>
              </div>
            </div>
            <div class="vx-col md:w-1/3 w-full cursor-pointer flex">
              <div class="md:w-1/4 p-2 flex " style="justify-content: center;align-items: center;" @click="updateBookmark(formData)" v-if="this.formData.isBookmark == false">
                <vx-tooltip
                  color="warning"
                  :text="this.$t('articleDetail.save')">
                  <feather-icon icon ="BookmarkIcon" style="vertical-align: bottom;width: 18px;"></feather-icon>
                </vx-tooltip>
              </div>
              <div class="md:w-1/4 p-2 flex cursor-pointer" style="justify-content: center;align-items: center;color:rgba(var(--vs-warning),1);" @click="updateBookmark(formData)" v-else>
                <vx-tooltip
                  color="warning"
                  :text="this.$t('articleDetail.unSavedChanges')">
                  <feather-icon icon ="BookmarkIcon" style="vertical-align: bottom;width: 18px;"></feather-icon>
                </vx-tooltip>
              </div>
              <div class="md:w-1/4 p-2 flex cursor-pointer" style="justify-content: center;align-items: center; ">
                <vx-tooltip
                  color="primary"
                  :text="this.$t('button.originalPost')">
                  <a target="_blank" :href="formData.url" style="color: #626262!important;">
                    <feather-icon icon ="CornerUpLeftIcon" style="vertical-align: bottom;width: 18px;"></feather-icon>
                  </a>
                </vx-tooltip>
              </div>
              <div class="md:w-1/4 p-2 flex cursor-pointer" :data-url = this.formData.url @click="copyLink" style="justify-content: center;align-items: center; ">
                <vx-tooltip
                  color="primary"
                  :text="this.$t('button.copyLink')">
                  <feather-icon  icon ="LinkIcon" style="vertical-align: bottom;width:18px"></feather-icon>
                </vx-tooltip>
              </div>
              <div class="md:w-1/4 p-2 flex cursor-pointer" style="justify-content: center;align-items: center;" @click="confirmSpam(formData)">
                <vx-tooltip
                  color="danger"
                  :text="this.$t('articleDetail.markSpam')">
                  <feather-icon icon ="Trash2Icon" style="vertical-align: bottom;width: 18px;"></feather-icon>
                </vx-tooltip>
              </div>
            </div>
          </div>
          <div class="vx-col mr-1" >
            <VuePerfectScrollbar
              ref="scrollDialog" class="scroll-area--nofications-dropdown p-0 size-content"
              :settings="settings" style="max-height: 87vh;">
              <div class="vx-col w-full mt-2 p-3" v-if="selectedContent">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <span class="font-bold" style="color: #CAC9CF;font-size: 12px;text-transform: uppercase;">{{$t('title.shades')}}</span>
                    <div v-if="formData.percentPositive == formData.percentNegative && formData.percentNegative == formData.percentNeurtal" class="vx-row" >
                      <div class="vx-col md:w-8/12 w-full flex">
                        <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;color: #BFBFC8;">
                          <feather-icon class="icon_shade_form color_Pos"  icon="SmileIcon"></feather-icon>
                          <span class="ml-2 color_Pos"><b>{{ formData.percentPositive || 0 }}%</b></span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;color: #BFBFC8;" >
                          <feather-icon class="icon_shade_form color_Nega" icon="FrownIcon"></feather-icon>
                          <span class="ml-2 color_Nega" ><b>{{ formData.percentNegative || 0 }}%</b></span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;color: #BFBFC8;">
                          <feather-icon class="icon_shade_form color_Neu" icon="MehIcon"></feather-icon>
                          <span class="ml-2 color_Neu"><b>{{ formData.percentNeurtal || 0 }}%</b></span>
                        </div>
                      </div>
                      <div class="md:w-4/12 w-full mt-2">
                        <vs-dropdown>
                          <label class="mr-1 text-primary" for="" style="font-size:13px">{{ textSelected }}</label>
                          <feather-icon icon="ChevronDownIcon" class="feather-drop text-primary"></feather-icon>
                          <vs-dropdown-menu style="width:140px">
                            <div class="w-full m-4">
                              <span class="font-medium">{{ $t('articleDetail.optionsShade') }}</span>
                            </div>
                            <vs-dropdown-item v-for="(shade, indexShade) in optionalShade" :key="indexShade" style="border-top: 1px solid #ccc" @click="updateClassification(formData, shade)">
                              <feather-icon :icon="shade.icon" class="feather-drop" :style="{color: shade.color}"></feather-icon>
                              <span class="ml-4">{{ shade.title }}</span>
                            </vs-dropdown-item>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>
                    </div>
                    <div v-else class="vx-row" >
                      <div class="vx-col md:w-8/12 w-full flex">
                        <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;color: #BFBFC8;">
                          <feather-icon class="icon_shade_form" :class="{color_Pos : this.formData.classification == 1}" icon="SmileIcon"></feather-icon>
                          <span class="ml-2" :class="{color_Pos : this.formData.classification == 1}"><b>{{ formData.percentPositive || 0 }}%</b></span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;color: #BFBFC8;" >
                          <feather-icon class="icon_shade_form" :class="{color_Nega : this.formData.classification == -1}" icon="FrownIcon"></feather-icon>
                          <span class="ml-2" :class="{color_Nega : this.formData.classification == -1}"><b>{{ formData.percentNegative || 0 }}%</b></span>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2" style="display: flex;align-items: center;color: #BFBFC8;">
                          <feather-icon class="icon_shade_form" :class="{color_Neu : this.formData.classification == 0}" icon="MehIcon"></feather-icon>
                          <span class="ml-2" :class="{color_Neu : this.formData.classification == 0}"><b>{{ formData.percentNeurtal || 0 }}%</b></span>
                        </div>
                      </div>
                      <div class="md:w-4/12 w-full mt-2">
                        <vs-dropdown>
                          <label class="mr-1 text-primary" for="" style="font-size:13px ">{{ textSelected }}</label>
                          <feather-icon icon="ChevronDownIcon" class="feather-drop text-primary"></feather-icon>
                          <vs-dropdown-menu style="width:140px">
                            <div class="w-full m-4">
                              <span class="font-medium">{{ $t('articleDetail.optionsShade') }}</span>
                            </div>
                            <vs-dropdown-item v-for="(shade, indexShade) in optionalShade" :key="indexShade" style="border-top: 1px solid #ccc" @click="updateClassification(formData, shade)">
                              <feather-icon :icon="shade.icon" class="feather-drop" :style="{color: shade.color}"></feather-icon>
                              <span class="ml-4">{{ shade.title }}</span>
                            </vs-dropdown-item>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col mt-2 p-4"  v-if="this.formData.beanType ==104 || this.formData.beanType == 105">
                  <span style="color: #CAC9CF;font-size: 20px">{{$t('title.interactive')}}</span>
                  <div class="vx-col">
                    <div class="vx-row mt-2" >
                      <div class="vx-card" style="width: 100px;padding: 5px 10px;">
                        <b style="color: #626262;margin-left: 2px;padding-left: 2px;">{{nFormatter(this.formData.comment)}}</b><span style="font-size: 12px"> {{$t('articleBookmark.comment')}}</span>
                      </div>
                      <div class="vx-card" style="width: 100px;padding: 5px 10px;margin-left: 5%;">
                        <b style="color: #626262;margin-left: 2px;">{{nFormatter(this.formData.share || 0)}}</b><span style="font-size: 12px"> {{$t('articleBookmark.share')}}</span>
                      </div>
                    </div>
                    <div class="vx-row vx-card pt-2 mt-2 w-full" style="display: flex;min-width: 400px !important;">
                      <div class="vx-row ml-2" style=" display:flex;flex-wrap: nowrap;">
                        <div class=" pl-2">
                          <img :src="this.formData.highlightReaction.icon" alt="" style="width:1.5rem">
                        </div>
                        <div class="vx-col md:w-2/3 w-full pl-0  pl-2">
                          <span class="text-size"><b>{{ nFormatter(this.formData.highlightReaction.value) || 0 }}</b></span>
                        </div>
                      </div>
                      <div class="vx-row ml-2" style=" display:flex;flex-wrap: nowrap;">
                        <div class=" pl-2">
                          <img :src="this.formData.totalReaction[0].icon" alt="" style="width:1.5rem">
                        </div>
                        <div class="vx-col md:w-2/3 w-full pl-0  pl-2">
                          <span class="text-size"><b>{{ nFormatter(this.formData.totalReaction[0].value) || 0 }}</b></span>
                        </div>
                      </div>
                      <div class="vx-row ml-2" style="  display:flex;flex-wrap: nowrap;">
                        <div class="pl-2">
                          <img :src="this.formData.totalReaction[1].icon" alt="" style="width:1.5rem">
                        </div>

                        <div class="vx-col md:w-2/3 w-full pl-0  pl-2">
                            <span
                              class="text-size"><b>{{ nFormatter(this.formData.totalReaction[1].value) || 0 }}</b></span>
                        </div>
                      </div>
                      <div class="vx-row ml-2" style=" display:flex;flex-wrap: nowrap;">
                        <div class=" pl-2">
                          <img :src="this.formData.totalReaction[2].icon" alt="" style="width:1.5rem;">
                        </div>

                        <div class="vx-col md:w-2/3 w-full pl-0  pl-2">
                            <span
                              class="text-size"><b>{{ nFormatter(this.formData.totalReaction[2].value) || 0 }}</b></span>
                        </div>
                      </div>
                      <div class="vx-row ml-2" style=" display:flex;flex-wrap: nowrap;">
                        <div class=" pl-2">
                          <img :src="this.formData.totalReaction[3].icon" alt="" style="width:1.5rem">
                        </div>

                        <div class="vx-col md:w-2/3 w-full pl-0  pl-2">
                            <span
                              class="text-size"><b>{{ nFormatter(this.formData.totalReaction[3].value) || 0 }}</b></span>
                        </div>
                      </div>
                      <div class="vx-row ml-2" style=" display:flex;flex-wrap: nowrap;">
                        <div class=" pl-2">
                          <img :src="this.formData.totalReaction[4].icon" alt="" style="width:1.5rem">
                        </div>

                        <div class="vx-col md:w-2/3 w-full pl-0  pl-2">
                            <span
                              class="text-size"><b>{{ nFormatter(this.formData.totalReaction[4].value) || 0 }}</b></span>
                        </div>
                      </div>
                      <div class="vx-row ml-2" style=" display:flex;flex-wrap: nowrap;">
                        <div class="pl-2">
                          <img :src="this.formData.totalReaction[5].icon" alt="" style="width:1.5rem">
                        </div>

                        <div class="vx-col md:w-2/3 w-full pl-0  pl-2">
                            <span
                              class="text-size"><b>{{ nFormatter(this.formData.totalReaction[5].value) || 0 }}</b></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="this.formData.beanType ==104 || this.formData.beanType == 105" class="vx-card p-4">
                  <div class="vx-row ml-0 mb-2" style="border-bottom: 1px solid rgba(191, 191, 200,0.5);">
                    <div class="md:w-1/2 vx-row ml-0">
                      <div class=" title-line " v-if="formData.img !=null" style="">
                        <img  @error="imgError" :src="formData.img" style="width:4rem;height:4rem;border-radius: 50%">
                      </div>
                      <div class=" title-line " v-else style="text-align:center;">
                        <img  src="@/assets/images/logo/no_image.png" style="width:4rem;height:4rem;">
                      </div>
                      <div class="name_user" >
                        <span style="font-size: 16px;color: #626262;font-weight: 500">Facebook</span>
                        <span style="font-size: 14px;color: rgb(191, 191, 200);">{{this.formData.name}}</span>
                      </div>
                    </div>
                    <div class="md:w-1/2 pr-4 " style="display: flex;justify-content: flex-end;align-items: center;">
                      <span class="text-form-time"><span style="font-weight: 500;color: rgb(191, 191, 200)">{{ formData.publishDateForm }}</span></span>
                    </div>
                  </div>
                  <div class="vx-row content-from mt-2 p-2">
                    <p v-html="formData.fullContents"  class="inline text-content-form ">
                    </p>
                  </div>
                </div >
                <div v-else class="content-mid mt-6 vx-card p-2">
                  <div class="vx-col" style="display: flex; flex-direction: column;">
                    <span class="facebook-name text-form-time" >{{$t('articleDetail.from')}}: <b>{{ formData.name }}</b></span>
                    <span class="text-form-time">{{$t('articleDetail.at')}}: <span style="font-weight: 500">{{ formData.publishDateForm }}</span></span>
                  </div>
                  <div class="vx-col w-full mt-2 title-line " v-if="formData.img !=null" style="text-align:center">
                    <img  @error="imgError" :src="formData.img" style="width:15rem;height:auto">
                  </div>
                  <div class="vx-col w-full mt-2 title-line " v-else style="text-align:center;">
                    <img  src="@/assets/images/logo/no_image.png" style="width:15rem;height:auto">
                  </div>
                  <div class="content-from mt-2">
                    <p v-html="formData.fullContents"  class="inline text-content-form ">
                    </p>
                  </div>
                </div>
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';
import authConfig from '@/../auth_config.json';
import NoImage from '@/assets/images/logo/no_image.png';
import emoji from '@/assets/images/icon-facebook/emoji.png';
import like from '@/assets/images/icon-facebook/like.png';
import love from '@/assets/images/icon-facebook/love.png';
import care from '@/assets/images/icon-facebook/care.png';
import haha from '@/assets/images/icon-facebook/haha.png';
import wow from '@/assets/images/icon-facebook/wow.png';
import sad from '@/assets/images/icon-facebook/sad.png';
import angry from '@/assets/images/icon-facebook/angry-face.png';
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    vSelect,
    Datepicker,
    NoImage,
    DateRangePicker,
    VueSimpleSuggest,
    authConfig,
    VuePerfectScrollbar
  },
  props: {
    initial: {
      default: true
    },
    showFacebookProfile:{default:true},
    showFacebookPrivate:{default:true},
    showFacebookComment:{default:true},
    showIgPost:{default:true},
    showIgComment:{default:true},
    showNewsPost:{default:true},
    showTiktok:{default:true},
    showTiktokTrendings:{default:true},
    showTwitter:{default:true},
    showTopic: {default: true},
    topicId: {},
    selectedTopic: {},
    classification: {default:null},
    facePost:{},
    faceComment:{},
    igPost:{},
    igComment:{},
    newsPost:{},
    tiktok:{},
    twitter:{},
    getAll:{default:true},
    labelNews:{default:false},
    labelSocial:{default:false},
    showNewsPostDetail: {default:false},
    showFilterCase:{default:true},
    refreshData:{default:0},
    showYoutube:{default:true},
    showYoutubeComment:{default:true},
    showForum: {default:true},
    showForumComment:{default:true},
    showGoogle:{default:true}
  },
  data() {
    return {
      optionalShade: [
        {icon: 'SmileIcon', color: '#007AFE', title: this.$t('articleDetail.positive'), classification: 1},
        {icon: 'FrownIcon', color: '#F12B2C', title: this.$t('articleDetail.negative'), classification: -1},
        {icon: 'MehIcon', color: '#FEC400', title: this.$t('articleDetail.neutral'), classification: 0}
      ],
      textSelected: this.$t('articleDetail.optionsShade'),

      resizeContent: '620px',
      checkPositive:true,
      checkNegative:true,
      checkNeutral:true,
      checkBookmark:true,
      lengthSourceData:null,
      optionalSort:[
        {label:this.$t('articleDetail.newsFeed'), value:0},
        {label:this.$t('articleDetail.newsOld'), value:1},
        {label:this.$t('articleDetail.decreaseLevel'), value:3},
        {label:this.$t('articleDetail.ascendingLevel'), value:2}
      ],
      valueOption: null,
      selected:[],
      checkBoxAllSocial:true,
      checkBoxAllNews:true,
      selectedContent:false,
      simpleSuggestionList:[],
      loadDataNofity:0,
      pageNumber: 0,
      panel: 'range',
      topic:null,
      optionalsTopic:[],
      userTopics:[],
      valueText:null,
      valueOldestPost:null,
      valueInteractive:null,
      valueInteractiveUp:null,
      radio:"SmileIcon",
      date:null,
      optionalsValue:"Tất cả chủ đề",
      checkbox:false,
      valueCheckbox:[],
      searchByIdAndName:null,
      currentItemView:'item-list-view',
      checkBox:false,
      rowDatas:[],
      pageNumbers:null,
      totalPages:0,
      perPage:10,
      maxPageNumbers:6,
      lastPage: 1,
      currentPage:1,
      gridApi:null,

      popupActive:false,

      dialogName:null,
      titleDialog:null,

      bookmark:true,
      star:false,

      valueRadio:null,

      filter: true,

      responseDataTopic:[],
      topicName:null,
      rangeDate:null,
      formData:{
        url:null,
        title:null,
        fullContents:null,
        publishDateForm:null,
        name:null,
        img:null,
        keyword:null,
        fromDate:null,
        toDate:null,
        isSpam:false,
        isBookMark:false,
        id:null,
        optionalNegative:[],
        optionalNeutral:[],
        optionalPositive:[],
        beanType:null,
        classification:null,
        percentNegative:null,
        percentNeurtal:null,
        percentPositive:null,
        activeClassification:false,
        share:null,
        comment:null,
        totalReaction:[],
        highlightReaction:[]
      },
      userName:[],
      totalElements:null,
      beanType:null,

      // checkbox
      dataCheckBox:false,
      dataCheckBox2:false,
      dataCheckBox3:false,
      valueCheckBoxClassification:null,
      pooledNews:null,
      newsPostCheckBox: true,
      facePostCheckBox: true,
      faceCommentCheckBox: true,
      igPostCheckBox: true,
      igCommentCheckBox: true,
      findAll:false,
      youtubeCheckBox:true,
      forumCheckbox:true,
      tiktokCheckbox : true,
      twitterCheckbox : true,
      googleCheckbox:true,
      isPrivate:false,
      otherCheckboxFacebook:[],
      checkIndexOther:null,

      //Date
      dateNow :null,

      //value text classification
      valueTextPositive:null,
      valueTextNegative:null,
      valueTextInter:null,
      valueTextAll:null,
      valueTextUndefined:null,

      offset:null,
      pageSize:null,
      totalContent:0,

      //classification
      item:null,
      origin:null,
      spam:false,

      //Spam
      itemSpam:null,
      News:false,
      Social:false,

      //hover
      active:false,
      reactionItem:[
        {text: 'all', icon: emoji, label: this.$t('articleBookmark.all')},
        {text: 'like', icon:like,label: this.$t('articleBookmark.like')},
        {text: 'love', icon:love,label: this.$t('articleBookmark.love')},
        {text: 'haha', icon:haha,label:'Haha'},
        {text: 'wow', icon:wow,label: this.$t('articleBookmark.wow')},
        {text: 'care', icon:care,label: this.$t('articleBookmark.care')},
        {text: 'sad', icon:sad,label: this.$t('articleBookmark.sad')},
        {text: 'angry', icon:angry,label: this.$t('articleBookmark.angry')}
      ],
      labelReaction: this.$t('articleBookmark.all'),
      selectedAngry:null,
      selectedCare:null,
      selectedHaha:null,
      selectedLike:null,
      selectedLove:null,
      selectedSad:null,
      selectedWow:null,
      iconFilter:null,

      dateRange: {
        endDate: new Date(),
        startDate: (() => { let date = new Date ();
          date.setDate(date.getDate() - 6);
          date.setHours(0,0,0);
          return date
        })()
      },
      settings: {
        wheelSpeed: .30,
        suppressScrollX: true
      },
      otherCheckbox:[],
      sourceData:[]

    }
  },
  filters:{
    date(val){
      return val ? moment(val).format('DD/MM/YYYY') : ''
    },
  },
  watch:{
    refreshData :function(newVal, oldVal){
      this.currentPage = 1;
      this.loadData();
    }
  },
  computed:{
    checkBoxAllData:{
      get(){
        return this.findAll;
      },
      set(val){
        this.findAll = val;
        this.checkAll(val);
        this.currentPage = 1;
        this.checkboxAll();
        this.$vs.loading();
        this.loadData();
      }
    },
    checkBoxFacePost:{
      get(){
        return this.facePostCheckBox;
      },
      set(val){
        this.facePostCheckBox = val;
        this.currentPage = 1;
        this.checkboxAll();
        this.$vs.loading();
        this.loadData();
      }
    },
    checkBoxIgPost:{
      get(){
        return this.igPostCheckBox;
      },
      set(val){
        this.igPostCheckBox = val;
        this.currentPage = 1;
        this.checkboxAll();
        this.$vs.loading();
        this.loadData();
      }
    },
    checkBoxIgComment:{
      get(){
        return this.igCommentCheckBox;
      },
      set(val){
        this.igCommentCheckBox = val;
        this.currentPage = 1;
        this.checkboxAll();
        this.$vs.loading();
        this.loadData();
      }
    },
    checkBoxPrivate:{
      get(){
        return this.isPrivate;
      },
      set(val){
        this.isPrivate = val;
        this.currentPage = 1;
        // this.checkboxPrivate(val);
        this.checkboxAll();
        this.$vs.loading();
        this.loadData();
      }
    },
    checkBoxFaceComment:{
      get(){
        return this.faceCommentCheckBox;
      },
      set(val){
        this.faceCommentCheckBox = val;
        this.currentPage = 1;
        this.checkboxAll();
        this.$vs.loading();
        this.loadData();
      }
    },
    checkBoxNews:{
      get(){
        return this.newsPostCheckBox;
      },
      set(val){
        this.newsPostCheckBox = val;
        this.currentPage = 1;
        this.$vs.loading();
        this.checkboxAll();
        this.loadData();
      }
    },
    checkBoxYoutube:{
      get(){
        return this.youtubeCheckBox;
      },
      set(val){
        this.youtubeCheckBox = val;
        this.currentPage = 1;
        this.$vs.loading();
        this.checkboxAll();
        this.loadData();
      }
    },
    checkBoxTiktok:{
      get(){
        return this.tiktokCheckbox;
      },
      set(val){
        this.tiktokCheckbox = val;
        this.currentPage = 1;
        this.$vs.loading();
        this.checkboxAll();
        this.loadData();
      }
    },
    checkBoxTwitter:{
      get(){
        return this.twitterCheckbox;
      },
      set(val){
        this.twitterCheckbox = val;
        this.currentPage = 1;
        this.$vs.loading();
        this.checkboxAll();
        this.loadData();
      }
    },
    checkBoxForum:{
      get(){
        return this.forumCheckbox;
      },
      set(val){
        this.forumCheckbox = val;
        this.currentPage = 1;
        this.$vs.loading();
        this.checkboxAll();
        this.loadData();
      }
    },
    checkBoxGoogle:{
      get(){
        return this.googleCheckbox;
      },
      set(val){
        this.googleCheckbox = val;
        this.currentPage = 1;
        this.$vs.loading();
        this.checkboxAll();
        this.loadData();
      }
    },
    checkBoxPositive:{
      get(){
        return this.checkPositive;
      },
      set(val){
        this.checkPositive =val
        if(this.checkBoxNeutral == true) {
          this.checkNeutral = true;
        } else {
          this.checkNeutral = false;
        }
        if(this.checkBoxNegative == true){
          this.checkNegative = true;
        } else {
          this.checkNegative = false;
        }
        this.currentPage = 1;
        this.loadData();
      }
    },
    checkBoxNegative:{
      get(){
        return this.checkNegative;
      },
      set(val){
        this.checkNegative =val
        if(this.checkBoxNeutral == true) {
          this.checkNeutral = true;
        } else {
          this.checkNeutral = false;
        }
        if(this.checkBoxPositive == true){
          this.checkPositive = true;
        } else {
          this.checkPositive = false;
        }
        this.currentPage = 1;
        this.loadData();
      }
    },
    checkBoxNeutral:{
      get(){
        return this.checkNeutral;
      },
      set(val){
        this.checkNeutral =val
        if(this.checkBoxPositive == true){
          this.checkPositive = true;
        } else {
          this.checkPositive = false;
        }
        if(this.checkBoxNegative == true){
          this.checkNegative = true;
        } else {
          this.checkNegative = false;
        }
        this.currentPage = 1;
        this.loadData();
      }
    },
    sortSelected:{
      get(){
        let obj = this.optionalSort.find(el => this.valueOption === el.value );
        if(!obj) {
          return null;
        }
        return {
          label :obj.label,
          value: this.valueOption
        }
      },
      set(obj){
        if (!obj){
          this.valueOption = null;
        }
        else {
          this.valueOption = obj.value;
        }
      }
    },
    topicSelected:{
      get(){
        let label = null;
        let object = this.optionalsTopic.find(el => el.value === this.topicName);
        if(!object){
          return null
        }

        if(object && object.label.length > 13){
          label = object.label.slice(0,13) + '...';
        }
        else{
          label = object.label;
        }

        return {
          label:label,
          value:this.topicName
        }
      },
      set(object){
        if(!object){
          this.topicName = null;
        }
        else{
          this.topicName = object.value
          this.topicId = object.value;
        }
      }
    },
  },
  methods:{
    checkboxPrivate(val) {
      if (val == true) {
        this.facePostCheckBox = false;
        this.faceCommentCheckBox = false;
        this.newsPostCheckBox = false;
        this.youtubeCheckBox = false;
        this.forumCheckbox = false;
        this.googleCheckbox = false;
        this.findAll = false
      } else {
        this.facePostCheckBox = true;
        this.faceCommentCheckBox = true;
        this.newsPostCheckBox = true;
        this.youtubeCheckBox = true;
        this.forumCheckbox = true;
        this.googleCheckbox = true;
        this.findAll = true
      }
    },
    updateBookmarkMany(){
      if(this.selected.length == 0){
        this.$vs.notify({
          text:'Bạn chưa chọn tin nào',
          color:'danger',
          iconPack: 'feather',
          icon: 'icon-alert',
        })
        return false;
      }
      const list = this.selected.map(el=>{
        let obj ={};
        obj['id'] = el.id
        return obj;
      });
      this.$vs.loading();
      this.$processor.post('/user-data/update-bookmark-many',list).then(() =>{
        this.checkBookmark = false;
        this.selected=[];
        this.loadData();
        this.$vs.loading.close();
        this.$vs.notify({
          text: this.$t('articleBookmark.textSave'),
          iconPack: 'feather',
          icon: 'icon-alert',
          color: 'primary'
        })
      }).catch((err)=>{
        this.$vs.loading.close();
        this.selected=[];
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    confirmSpamMany(){
      if(this.selected.length == 0){
        this.$vs.notify({
          text:'Bạn chưa chọn tin nào',
          color:'danger',
          iconPack: 'feather',
          icon: 'icon-alert',
        })
        return false;
      }
      const list = this.selected.map(el=>{
        let obj ={};
        obj['id'] = el.id
        return obj;
      });
      this.$vs.loading();
      this.$processor.post('/user-data/spam/many',list).then(() =>{
        this.loadData();
        this.selected=[];
        this.$vs.loading.close();
        this.$vs.notify({
          text: this.$t('articleBookmark.isSpamSuccess'),
          iconPack: 'feather',
          icon: 'icon-alert',
          color: 'primary'
        })
      })
        .catch((err)=>{
          this.selected=[];
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    checkAll(val){
      this.facePostCheckBox = val;
      this.faceCommentCheckBox = val;
      this.igPostCheckBox = val;
      this.igCommentCheckBox = val;
      this.newsPostCheckBox = val;
      this.tiktokCheckbox = val;
      this.twitterCheckbox = val;
      this.youtubeCheckBox = val;
      this.forumCheckbox = val;
      this.googleCheckbox = val;
    },
    checkboxAll(){
      if(this.newsPostCheckBox && this.twitterCheckbox && this.tiktokCheckbox && this.facePostCheckBox && this.faceCommentCheckBox && this.igPostCheckBox && this.igCommentCheckBox && this.youtubeCheckBox && this.forumCheckbox && this.googleCheckbox ){
        this.findAll = true;
        // this.isPrivate = false;
      }else {
        this.findAll = false;
        // this.isPrivate = false;
      }
    },
    openPost(item){
      let url = item.link;
      window.open(url,'_blank');
    },
    backgroundHover: function(){
      document.getElementsByClassName('vs-component vs-dropdown--item')[0].style.background='#fff';
    },
    findSort(){
      if (this.valueOption == 0){
        this.clickNewPost();
      }
      if (this.valueOption == 1){
        this.clickPriceDown();
      }
      if (this.valueOption == 2){
        this.clickPriceUp()
      }
      if (this.valueOption == 3){
        this.clickDown();
      }
      this.$vs.loading();
      this.currentPage = 1;
      this.$vs.loading();
      this.loadData();
    },
    openItem:function (item){
      this.selectedContent=true;
      if(item.highlightReaction) {
        this.formData.highlightReaction = item.highlightReaction;
      }
      if (item.totalReaction.length > 0) {
        this.formData.totalReaction = item.totalReaction.filter(el=>{
          return   el.text != "like";
        });
      }
      if (this.formData.img) {
        this.formData.img = null;
      }
      if (item.share != null) {
        this.formData.share = item.share;
      }
      if (item.comment != null) {
        this.formData.comment = item.comment;
      }
      this.formData.activeClassification = item.activeClassification;
      this.formData.classification = item.classification
      if  (item.percentPositive) {
        this.formData.percentPositive = item.percentPositive;
        this.formData.percentNeurtal = item.percentNeurtal;
        this.formData.percentNegative = item.percentNegative;
      }
      this.formData.title = item.title;
      if (item.specialFields && item.specialFields.from) {
        let data = JSON.parse(item.specialFields.from);
        this.formData.name = data.name;
      }
      if (item.specialFields.author) {
        this.formData.name = item.specialFields.author = 'null' ? 'Ẩn danh' : item.specialFields.author;
      }
      if (item.optionalPositive) {
        this.formData.optionalPositive = item.optionalPositive;
      }else {
        this.formData.optionalPositive=[];
      }
      if (item.optionalNeutral) {
        this.formData.optionalNeutral = item.optionalNeutral;
      }else {
        this.formData.optionalNeutral = [];
      }
      if (item.optionalNegative) {
        this.formData.optionalNegative = item.optionalNegative;
      }else {
        this.formData.optionalNegative = [];
      }

      if (item.specialFields && item.specialFields.channel_title) {
        this.formData.name = item.specialFields.channel_title;
      }
      if (item.link) {
        this.formData.url = item.link;
      }
      if (item.beanType) {
        this.formData.beanType = item.beanType;
      }
      this.formData.id=item.id;
      this.formData.fullContents = item.displayFullContentOrigin;
      this.formData.isSpam=item.isSpam;
      this.formData.isBookmark=item.isBookmark;
      this.formData.publishDateForm = moment(item.publishDate.replace('Z', '')).format("DD/MM/YYYY HH:mm");
      if (item.attachmentUrls.length > 0) {
        let img = item.attachmentUrls[0];
        this.formData.img = img.url;
      }
    },
    getDataSource: function(){
      const payload = {
        pageNumber: 0,
        pageSize: 20
      }
      this.$processor.post('website/get-all', payload).then((response) => {
        this.sourceData = response.data.content;
        this.sourceData.forEach(el => el.checkBoxOther = true);
        this.sourceData = this.sourceData.filter(el => el.activeWebsite == true);
        this.lengthSourceData=this.sourceData.length;
      })
    },
    directionNews: function(event){
      window.open(event.link, "_blank");
    },
    validURL: function(str) {
      var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return !!pattern.test(str);
    },
    imgError(image){
      image.target.src = NoImage;
    },
    highlight: function(text){
      let inputText = document.getElementById("inputText");
      let innerHTML = inputText.innerHTML;
      let index = innerHTML.indexOf(text);
      if(index >= 0){
        innerHTML = innerHTML.substring(0,index) + "<span class ='highlight'>" + innerHTML.substring(index, index+ text.length) + "</span>" + innerHTML.substring(index +text.length);
        inputText.innerHTML = innerHTML;
      }
    },

    // Facebook-API

    articleChangeFacePost:function(){
      if(this.checkBoxFacePost == true){
        this.checkBoxFacePost = !this.checkBoxFacePost;
        this.checkBoxAllData = false;
        this.facePostCheckBox = false;
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage =1;
      } else {
        this.facePostCheckBox = true;
        this.checkBoxFacePost=!this.checkBoxFacePost;
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage =1;
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTwitter && this.checkBoxTiktok && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeFaceComment:function(){
      if(this.checkBoxFaceComment == true ){
        this.checkBoxFaceComment=!this.checkBoxFaceComment;
        this.checkBoxAllData = false;
        this.faceCommentCheckBox = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage =1
      }
      else{
        this.checkBoxFaceComment = !this.checkBoxFaceComment;
        this.faceCommentCheckBox = true;
        this.findAll = false;
        this.currentPage =1
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTwitter && this.checkBoxTiktok && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeIgPost:function(){
      if(this.checkBoxIgPost == true ){
        this.checkBoxIgPost=!this.checkBoxIgPost;
        this.checkBoxAllData = false;
        this.igPostCheckBox = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage =1
      }
      else{
        this.checkBoxIgPost = !this.checkBoxIgPost;
        this.igPostCheckBox = true;
        this.findAll = false;
        this.currentPage =1
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTwitter && this.checkBoxTiktok && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeIgComment:function(){
      if(this.checkBoxIgComment == true ){
        this.checkBoxIgComment=!this.checkBoxIgComment;
        this.checkBoxAllData = false;
        this.igCommentCheckBox = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage =1
      }
      else{
        this.checkBoxIgComment = !this.checkBoxIgComment;
        this.igCommentCheckBox = true;
        this.findAll = false;
        this.currentPage =1
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTwitter && this.checkBoxTiktok && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeNews:function(){
      if(this.checkBoxNews == true){
        this.checkBoxNews = !this.checkBoxNews;
        this.checkBoxAllData = false;
        this.newsPostCheckBox = false;
        this.findAll = false;
        this.currentPage =1
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      else{
        this.checkBoxNews =! this.checkBoxNews;
        this.newsPostCheckBox = true;
        this.findAll = false;
        this.currentPage = 1;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgComment && this.checkBoxIgPost && this.checkBoxTiktok && this.checkBoxTwitter && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeYoutube: function(){
      if(this.checkBoxYoutube == true){
        this.checkBoxYoutube =! this.checkBoxYoutube;
        this.checkBoxAllData = false;
        this.youtubeCheckBox = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage = 1;
      }
      else{
        this.checkBoxYoutube = !this.checkBoxYoutube;
        this.youtubeCheckBox = true;
        this.findAll = false;
        this.currentPage = 1;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTiktok && this.checkBoxTwitter && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeTiktok: function(){
      if(this.checkBoxTiktok == true){
        this.checkBoxTiktok =! this.checkBoxTiktok;
        this.checkBoxAllData = false;
        this.tiktokCheckbox = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage = 1;
      }
      else{
        this.checkBoxTiktok = !this.checkBoxTiktok;
        this.tiktokCheckbox = true;
        this.findAll = false;
        this.currentPage = 1;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTiktok && this.checkBoxTwitter && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeTwitter: function(){
      if(this.checkBoxTwitter == true){
        this.checkBoxTwitter =! this.checkBoxTwitter;
        this.checkBoxAllData = false;
        this.twitterCheckbox = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage = 1;
      }
      else{
        this.checkBoxTwitter = !this.checkBoxTwitter;
        this.twitterCheckbox = true;
        this.findAll = false;
        this.currentPage = 1;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxForum == true) {
          this.forumCheckbox = true;
        } else {
          this.forumCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTiktok && this.checkBoxTwitter && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeForum: function(){
      if(this.checkBoxForum == true){
        this.forumCheckbox = false;
        this.checkBoxForum = !this.checkBoxForum;
        this.checkBoxAllData = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage = 1;
      }
      else{
        this.checkBoxForum = !this.checkBoxForum;
        this.forumCheckbox = true;
        this.findAll = false;
        this.currentPage  = 1;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTiktok && this.checkBoxTwitter && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    articleChangeGoogle: function(){
      if(this.checkBoxGoogle == true){
        this.googleCheckbox = false;
        this.checkBoxGoogle = !this.checkBoxGoogle;
        this.checkBoxAllData = false;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if ( this.checkBoxForum == true) {
          this.forumCheckbox = true ;
        } else {
          this.forumCheckbox = false ;
        }
        this.findAll = false;
        this.currentPage  = 1;
      }
      else{
        this.checkBoxGoogle = !this.checkBoxGoogle;
        this.googleCheckbox = true;
        this.findAll = false;
        this.currentPage  = 1;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if ( this.checkBoxForum == true) {
          this.forumCheckbox = true ;
        } else {
          this.forumCheckbox = false ;
        }
      }
      if(this.checkBoxFacePost && this.checkBoxIgPost && this.checkBoxIgComment && this.checkBoxTiktok && this.checkBoxTwitter && this.checkBoxFaceComment && this.checkBoxNews && this.checkBoxYoutube  && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.checkBoxAllData = true;
        this.findAll = true;
      }
      this.$vs.loading();
      this.loadData();
    },

    articleChangeOther: function(event, index){
      const resultDomain = event.url.split('//').pop().split('wwww.').pop().split('/', 1).pop();
      let indexItem = this.otherCheckbox.indexOf(resultDomain);
      if(event.checkBoxOther){
        if(indexItem !== -1){
          this.otherCheckbox.splice(indexItem , 1);
        }
        event.checkBoxOther = false;
        this.findAll = false;
        this.currentPage = 1;
        if (this.checkBoxFacePost == true) {
          this.facePostCheckBox = true;
        } else {
          this.facePostCheckBox = false;
        }
        if (this.checkBoxFaceComment == true) {
          this.faceCommentCheckBox = true;
        } else {
          this.faceCommentCheckBox = false;
        }
        if (this.checkBoxIgPost == true) {
          this.igPostCheckBox = true;
        } else {
          this.igPostCheckBox = false;
        }if (this.checkBoxIgComment == true) {
          this.igCommentCheckBox = true;
        } else {
          this.igCommentCheckBox = false;
        }
        if (this.checkBoxNews == true) {
          this.newsPostCheckBox = true;
        } else {
          this.newsPostCheckBox = false;
        }
        if (this.checkBoxYoutube == true) {
          this.youtubeCheckBox = true;
        } else {
          this.youtubeCheckBox = false;
        }
        if (this.checkBoxTiktok == true) {
          this.tiktokCheckbox = true;
        } else {
          this.tiktokCheckbox = false;
        }if (this.checkBoxTwitter == true) {
          this.twitterCheckbox = true;
        } else {
          this.twitterCheckbox = false;
        }
        if ( this.checkBoxForum == true) {
          this.forumCheckbox = true ;
        } else {
          this.forumCheckbox = false ;
        }
        if ( this.checkBoxGoogle == true) {
          this.googleCheckbox = true ;
        } else {
          this.googleCheckbox = false ;
        }
      }
      else{
        this.otherCheckbox.push(resultDomain)
        event.checkBoxOther = true;
        this.findAll = false;
        this.currentPage = 1;
        this.checkBoxFacePost = false;
        this.checkBoxFaceComment = false;
        this.checkBoxIgPost = false;
        this.checkBoxIgComment = false;
        this.checkBoxNews = false;
        this.checkBoxYoutube = false;
        this.checkBoxTwitter = false;
        this.checkBoxTiktok = false;
        this.checkBoxForum = false;
        this.checkBoxGoogle = false;
        this.checkBoxAllData = false;
      }
      if(this.checkBoxNews && this.checkBoxTwitter && this.checkBoxTiktok && this.checkBoxFacePost && this.checkBoxFaceComment && this.checkBoxIgPost && this.checkBoxIgComment  && this.checkBoxYoutube && this.checkBoxForum && this.checkBoxGoogle && this.otherCheckbox.length == this.lengthSourceData){
        this.findAll = true;
        this.checkBoxAllData = true;
      }
      this.$vs.loading();
      this.loadData();
    },
    getAllData: function(){
      this.$vs.loading();
      if ( this.checkBoxAllData == true){
        this.checkBoxGoogle = false;
        this.checkBoxForum = false;
        this.checkBoxYoutube = false;
        this.checkBoxNews = false;
        this.checkBoxTwitter = false;
        this.checkBoxTiktok = false;
        this.checkBoxFaceComment = false;
        this.checkBoxFacePost = false;
        this.checkBoxIgPost = false;
        this.checkBoxIgComment = false;
        this.checkBoxAllData = false;
        this.sourceData.forEach(el => el.checkBoxOther = false);

      } else {
        this.checkBoxGoogle = true;
        this.checkBoxForum = true;
        this.checkBoxYoutube = true;
        this.checkBoxTiktok = true;
        this.checkBoxTwitter = true;
        this.checkBoxNews = true;
        this.checkBoxFaceComment = true;
        this.checkBoxFacePost = true;
        this.checkBoxIgPost = true;
        this.checkBoxIgComment = true;
        this.checkBoxAllData = true;
        this.sourceData.forEach(el => el.checkBoxOther = true);

      }
      this.facePostCheckBox = false;
      this.faceCommentCheckBox = false;
      this.newsPostCheckBox = false;
      this.youtubeCheckBox  = false;
      this.tiktokCheckbox  = false;
      this.twitterCheckbox  = false;
      this.tiktokTrending = false;
      this.youtubeCheckBoxComment =  false;
      this.forumCheckbox = false;
      this.forumCheckboxComment = false;
      this.googleCheckbox = false;
      this.findAll = true;
      this.currentPage =1;
      // this.sourceData.forEach(el => el.checkBoxOther = false);
      this.otherCheckbox = [],
        this.otherCheckboxFacebook = [],
        this.checkIndexOther = null
      this.getListFacebook();
    },

    loadData: function(){
      this.$vs.loading();
      let payload ={
        pageNumber: this.pageNumber,
        pageSize:10,
        userDataElasticsearch:{classification: this.classification, topicId: this.topicId ? this.topicId : null, isSpam:false, isBookmark: true},
        recently: this.valueText,
        oldestPost: this.valueOldestPost,
        interactive:this.valueInteractive,
        interactiveAscending: this.valueInteractiveUp,
        newsPost: this.newsPostCheckBox ? 101:0,
        facePost: this.facePostCheckBox ? 104: 0,
        faceComment: this.faceCommentCheckBox ? 105:0,
        igPost: this.faceCommentCheckBox ? 119:0,
        igComment: this.faceCommentCheckBox ? 120:0,
        youtube:this.youtubeCheckBox ? 106 : 0,
        youtubeComment:this.youtubeCheckBox ? 107 : 0,
        forum: this.forumCheckbox ? 111 : 0,
        forumComment:this.forumCheckbox ? 112 : 0,
        google: this.googleCheckbox ? 113 : 0,
        tiktok : this.tiktokCheckbox ? 116: 0,
        tiktokTrending : this.tiktokCheckbox ? 117: 0,
        twitter : this.twitterCheckbox ? 118: 0,
        domain: this.otherCheckbox,
        privatePost:this.isPrivate,
        domainFacebook: this.otherCheckboxFacebook,
        fromDate: new Date(this.dateRange.startDate.setHours(0, 0, 0)),
        toDate: new Date(this.dateRange.endDate.setHours(23, 59, 59)),
        content: this.formData.keyword,
        hahaCount: this.selectedHaha,
        likeCount: this.selectedLike,
        loveCount: this.selectedLove,
        sadCount: this.selectedSad,
        wowCount: this.selectedWow,
        careCount: this.selectedCare,
        angryCount: this.selectedAngry,
        positive:this.checkPositive,
        neutral:this.checkNeutral,
        negative: this.checkNegative
      }
      if(this.checkBookmark){
        this.selectedContent = false;
      }
      if (!payload.newsPost && !payload.facePost && !payload.faceComment && !payload.igPost && !payload.youtube && !payload.forum && !payload.forumComment && !payload.google) {
        if (this.showFacebookProfile != "false") payload.facePost = 104
        if (this.showFacebookComment != "false") payload.faceComment = 105
        if (this.showNewsPost != "false") payload.newsPost = 101
        if(this.showYoutube != 'false') {payload.youtube  = 106; payload.youtubeComment = 107}
        if(this.showForum != 'false') {payload.forum = 111; payload.forumComment  = 112}
        if(this.showGoogle != false) payload.google =  113
        if(this.showTiktok != 'false') {payload.tiktok  = 116; payload.tiktokTrending = 117}
        if(this.showTwitter != 'false') payload.twitter =  118
        if(this.showIgPost != 'false') payload.igPost =  119
        if(this.showIgComment != 'false') payload.igComment =  120
      }

      this.$processor.post('/user-data/find-by-condition',payload).then(response =>{
        this.$vs.loading.close();
        this.rowDatas = response.data.content.map(el =>{
          if(el.domain){
            let name = el.domain.split("//").pop().replace("www.","");
            if(name.length > 15){
              el.domainName  = name.slice(0,15) + '...';
            }
            else{
              el.domainName = name;
            }
          }
          if(el.publishDate){
            el.publishDateForm = moment(el.publishDate).format("DD/MM/YYYY HH:mm");
          }
          if(el.fullContents && el.fullContents.length > 0){
            el.displayFullContent = el.fullContents.filter(item => item.type == "text").map((elements) => {
              if(elements.content){
                return elements.content.trim();
              }
            }).join("\n");
          }
          el.displayFullContentOrigin = el.displayFullContent || "";
          if(el.url){
            el.link = el.url;
          }
          if(el.specialFields.from){
            let username = JSON.parse(el.specialFields.from);
            el.name = username.name;
          }
          if(el.attachmentUrls && el.attachmentUrls.length > 0){
            let attachmentUrl = el.attachmentUrls[0];
            el.image = attachmentUrl.url;
          }
          if(el.specialFields.reactionCount >=0){
            el.reaction = el.specialFields.reactionCount;
          }
          if(el.specialFields.likeCount >=0 && el.reaction > 0){
            el.like = el.specialFields.likeCount;
            el.like_percent = (el.like/el.reaction * 100).toFixed(1)
          }
          if(el.specialFields.commentCount >=0){
            el.comment = el.specialFields.commentCount;
          }
          if(el.specialFields.shareCount >=0){
            el.share = el.specialFields.shareCount;
          }
          if(el.specialFields.commentCount >= 0){
            el.commentWebsite = el.specialFields.commentCount;
          }
          if(el.specialFields.hahaCount >=0 && el.reaction > 0){
            el.haha = el.specialFields.hahaCount;
            el.haha_percent = (el.haha/el.reaction * 100).toFixed(1);
          }
          if(el.specialFields.angryCount >=0 && el.reaction > 0){
            el.angry =  el.specialFields.angryCount;
            el.angry_percent = (el.angry/el.reaction * 100).toFixed(1);
          }
          if(el.specialFields.loveCount >=0 && el.reaction > 0){
            el.love = el.specialFields.loveCount;
            el.love_percent= (el.love/el.reaction *100).toFixed(1);
          }
          if(el.specialFields.sadCount >=0 && el.reaction > 0){
            el.sad = el.specialFields.sadCount;
            el.sad_percent = (el.sad/el.reaction *100).toFixed(1)
          }
          if(el.specialFields.careCount >= 0 && el.reaction > 0){
            el.care =el.specialFields.careCount;
            el.care_percent = (el.care/el.reaction *100).toFixed(1);
          }
          if(el.specialFields.wowCount >=0 && el.reaction > 0){
            el.wow = el.specialFields.wowCount;
            el.wow_percent = (el.wow/el.reaction *100).toFixed(1)
          }
          if(el.specialFields.author){
            el.name = el.specialFields.author.trim();
          }
          if(el.beanType){
            this.beanType = el.beanType;
          }
          if(el.specialFields && el.specialFields.channel_title){
            el.titleYoutube = el.specialFields.channel_title;
          }
          if(el.specialFields && el.specialFields.from){
            let name = JSON.parse(el.specialFields.from);
            el.userNameForum = name.author;
          }
          if(el.negative != null && el.normal != null && el.positive != null){
            const total = el.positive + el.negative + el.normal;
            el.percentPositive = !isNaN(((el.positive/total) * 100)) ? ((el.positive/total) * 100).toFixed(0) : 0;
            el.percentNegative = !isNaN(((el.negative/total) * 100)) ? ((el.negative/total) * 100).toFixed(0) : 0;
            el.percentNeurtal = !isNaN(((el.normal/total) * 100)) ? ((el.normal/total) * 100).toFixed(0) : 0;

            const arr = [];
            const result = (el.positive/total * 10).toFixed(0);
            for(let i =0;i<result;i++){
              arr.push(i);
            }
            el.optionalPositive = arr;

            const arrNeutral =[];
            const resultNeutral = (el.normal/total * 10).toFixed(0);
            for(let i=0;i<resultNeutral;i++){
              arrNeutral.push(i);
            }
            el.optionalNeutral = arrNeutral;

            const arrNegative = [];
            const resultNegative = 10 - (arr.length + arrNeutral.length);
            for(let i = 0;i < resultNegative;i ++){
              arrNegative.push(i);
            }
            el.optionalNegative = arrNegative
          }
          else{
            const arr = [];
            const result = 10;
            for(let i = 0; i< result ; i++){
              arr.push(i);
            }
            if(el.classification == 0){
              el.optionalNeutral = arr;
            }
            else if(el.classification == 1){
              el.optionalPositive = arr;
            }
            else if(el.classification == -1){
              el.optionalNegative = arr;
            }
          }

          let totalReaction =[
            {text:'all',value:el.like,icon:like,label:'Tất cả',percent:el.like_percent},
            {text:'like',value:el.like,icon:like,label:'Thích',percent:el.like_percent},
            {text:'love', value: el.love,icon:love,label:'Yêu thích',percent:el.love_percent},
            {text:'haha', value:el.haha,icon:haha,label:'Haha',percent:el.haha_percent},
            {text:'wow', value:el.wow,icon:wow,label:'Ngạc nhiên',percent:el.wow_percent},
            {text:'care', value: el.care,icon:care,label:'Thương thương',percent:el.care_percent},
            {text:'sad',value:el.sad,icon:sad,label:'Buồn',percent:el.sad_percent},
            {text:'angry',value:el.angry,icon:angry,label:'Phẫn nộ',percent:el.angry_percent}];
          const filter = totalReaction.sort(function(a,b){return a.value - b.value});
          this.totalReaction = totalReaction;
          el.highlightReaction = filter[6];
          if(!el.highlightReaction.value){
            el.highlightReaction = totalReaction[0];
          }
          totalReaction = totalReaction.filter(item => item.text != el.highlightReaction.text);
          el.totalReaction = totalReaction;

          if(el.specialFields.source){
            el.source = el.specialFields.source;
          }
          if(el.sourceName){
            el.sourceName = el.sourceName;
          }
          if(el.specialFields.source && el.specialFields.source.includes('group')){
            el.source = 'group'
          }
          if(el.displayFullContent){
            el.origin = el.displayFullContent;
            if(this.selectedTopic && this.selectedTopic.id){
              const listTopic = this.userTopics;
              this.changeClassificationColor(this.userTopics,el);
            }else{
              this.changeClassificationColorDetail(this.userTopics,el);
            }
          }
          el.active = false;
          el.activeClassification = false;
          return el;
        });
        this.totalPages = parseInt(response.data.totalPages,10);
        this.totalElements = response.data.totalElements;
        // this.pageNumbers = response.data.pageable.pageNumber;
        // this.offset = response.data.pageable.offset;
        this.totalContent = (this.pageNumber + 1) * this.perPage;
        if(this.totalElements == 0){
          this.totalContent = 0;
        }
        if(this.totalElements < 10){
          this.totalContent = this.totalElements;
        }
        if(this.totalContent > this.totalElements){
          this.totalContent = this.totalElements;
        }
        if(this.checkBookmark){
          if(this.rowDatas.length>0){
            this.openItem(this.rowDatas[0]);
          }
        }
        this.checkBookmark = true;
        this.$vs.loading.close();
      }).catch(() =>{this.$vs.loading.close();})
    },
    onGridReady(){
      if(this.$store.state.windowWidth <= 1024){
        this.maxPageNumbers = 5;
      }
      else{
        this.maxPageNumbers = 7;
      }
      if(this.$store.state.windowWidth > 1024){
        this.gridApi.sizeColumnsToFit();
      }
    },
    clickNewPost: function(){
      this.valueText = this.$t('articleDetail.newsFeed')
      this.valueOldestPost= null;
      this.valueInteractive = null;
      this.valueInteractiveUp = null;
      this.getListFacebook();
    },
    clickPriceDown: function(){
      this.$vs.loading();
      this.valueOldestPost = this.$t('articleDetail.newsOld')
      this.valueText =null;
      this.valueInteractive =null;
      this.valueInteractiveUp = null;
      this.loadData()
    },
    clickDown : function(){
      this.$vs.loading();
      this.valueInteractive =this.$t('articleDetail.decreaseLevel');
      this.valueText=null;
      this.valueOldestPost = null;
      this.valueInteractiveUp = null;
      this.loadData();
    },
    clickPriceUp : function(){
      this.$vs.loading();
      this.valueInteractiveUp =this.$t('articleDetail.ascendingLevel');
      this.valueText=null;
      this.valueOldestPost = null;
      this.valueInteractive = null;
      this.loadData();
    },
    reportSpam: function(){
      this.popupActive = false;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('articleBookmark.titleTick'),
        text: this.$t('articleBookmark.textTick'),
        accept: this.deleteRecord,
        cancel: this.deleteRecord,
        acceptText: this.$t('articleBookmark.acceptText'),
        cancelText: this.$t('articleBookmark.cancelText')
      })
    },
    reportSpamForm:function(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('articleBookmark.titleTick'),
        text: this.$t('articleBookmark.textTick'),
        accept: this.confirmDialog,
        cancel: this.confirmDialog,
        acceptText: this.$t('articleBookmark.acceptText'),
        cancelText: this.$t('articleBookmark.cancelText')
      })
    },

    deleteRecord:function(){
      this.popupActive =true
    },
    getValueCheckbox: function(){
      let value = this.optionalsTopics.filter(item => item.checked).map(el => el.value);
      this.valueCheckbox = value;
    },
    onChangePage:function(event){
      if (this.currentPage == this.lastPage) return;
      this.lastPage = event;
      this.$vs.loading();
      this.pageNumber = parseInt(event) -1;
      this.loadData();
      this.$vs.loading.close();
    },
    openDialog:function(item){
      if(this.formData.img){
        this.formData.img = null;
      }
      this.popupActive = true;
      this.formData.title = item.title;
      if(item.specialFields.from){
        let data = JSON.parse(item.specialFields.from);
        this.formData.name = data.name;
      }
      if(item.specialFields.author){
        this.formData.name = item.specialFields.author
      }
      if(item.specialFields && item.specialFields.from){
        const name = JSON.parse(item.specialFields.from);
        this.formData.name = name.author;
      }
      if(item.specialFields && item.specialFields.channel_title){
        this.formData.name = item.specialFields.channel_title;
      }
      if(item.url){
        this.formData.url = item.link;
      }
      this.formData.fullContents = item.displayFullContentOrigin;

      this.formData.publishDateForm = moment(item.publishDate.replace('Z','')).format("DD/MM/YYYY HH:mm");
      if(item.attachmentUrls.length > 0){
        let img = item.attachmentUrls[0];
        this.formData.img = img.url;
      }
      setTimeout(()=>{
        this.$refs.scrollDialog.$el.scrollTop = 0;
      }, 100);

    },
    changeStar:function(){
      this.bookmark = false;
      this.star = true;
    },
    changeBookmark:function(){
      this.bookmark = true;
      this.star = false;
    },
    getValueRadio: function(value){
      switch(value){
        case 'SmileIcon':
          return this.valueRadio = 0;
      }
    },
    getListFacebook: function(){
      this.valueTextAll = this.$t('articleBookmark.all')
      this.valueTextPositive = null;
      this.valueTextNegative = null;
      this.valueTextInter = null;
      this.classification = null;
      this.$vs.loading();
      this.loadData();

    },
    hideFilter: function(){
      this.filter = false;
    },
    showFilter: function(){
      this.filter = true;
    },
    checkedClassificationPositive: function(){
      this.$vs.loading();
      this.valueTextPositive = "Tích cực";
      this.valueTextAll = null;
      this.valueTextNegative = null;
      this.valueTextInter =  null;
      this.valueTextUndefined= null;
      this.classification = 1;
      this.currentPage =1;
      this.loadData();
      this.$vs.loading.close();

    },
    checkedClassificationNegative: function(){
      this.$vs.loading();
      this.valueTextNegative = "Tiêu cực";
      this.valueTextAll = null;
      this.valueTextPositive =  null;
      this.valueTextInter =null;
      this.valueTextUndefined = null;
      this.classification = -1;
      this.currentPage = 1;
      this.loadData();
      this.$vs.loading.close();

    },
    checkedClassificationInter: function(){
      this.$vs.loading();
      this.valueTextInter = "Trung lập";
      this.valueTextAll = null;
      this.valueTextPositive= null;
      this.valueTextNegative = null;
      this.valueTextUndefined = null;
      this.classification = 0;
      this.currentPage =1;
      this.loadData();
      this.$vs.loading.close();

    },
    checkedClassificationUndefined: function(){
      this.$vs.loading();
      // this.valueTextUndefined = "Chưa xác định";
      this.valueTextAll = null;
      this.valueTextPositive = null;
      this.valueTextPositive = null;
      this.valueTextInter= null;
      this.classification = 2;
      this.currentPage = 1;
      this.loadData();
      this.$vs.loading.close();
    },
    pooledNewsChecked: function(){
      this.$vs.loading();
      this.valueText = "Tin mới nhất"
      this.valueOldestPost = null;
      this.valueInteractive = null
      this.loadData();
      this.$vs.loading.close();

    },

    searchByIdAndNameInput: function(){
      if(!this.searchByIdAndName){
        this.getListFacebook();
      }
      else{
        const payload ={
          uid:this.searchByIdAndName
        };
        this.$processor.post('/facebook-queue/find-by-id',payload).then((response) =>{
          this.rowDatas = response.data;
          if(this.rowDatas){
            this.rowDatas.forEach(element => {
              let details = JSON.parse(element.details);
              element.name = details.name;
            });
            this.totalPages = parseInt(response.data.totalPages,10);
            this.pageNumbers = response.data.pageable.pageNumber;
          }
        })
          .catch(() =>{})
      }
    },

    updateClassification: function(item, shade){
      this.$vs.loading();
      const payload = {
        id: item.id,
        classification: shade.classification
      }
      this.$processor.post('/user-data/update-classification',payload).then(() =>{
        this.textSelected = shade.title;
        this.$vs.loading.close();
        this.loadData();
      }).catch((err) => {
        this.$vs.loading.close();
        this.$vs.notify({
            text: this.$t('articleDetail.update'),
            iconPack: 'feather',
            icon: 'icon-alert',
            color: 'danger'
        })
      })
    },
    changeClassificationColor: function(userTopic,item){
      item.displayFullContentOrigin = item.displayFullContent;
      if(item.origin){
        for (let topic of userTopic) {
          for (let keyword of topic.keywords) {
            let userKeyword = keyword.keyword
            let keywordIndex = item.displayFullContent.toLowerCase().indexOf(userKeyword.toLowerCase())
            if (keywordIndex >= 0 ) {
              item.displayFullContent = item.displayFullContent.slice(item.displayFullContent.slice(0, keywordIndex).lastIndexOf(".") + 1);

              if(item.classification == 1){
                if(!this.selectedTopic.id || topic.id == this.selectedTopic.id){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(39, 125, 246,1);font-weight: 500;">${userKeyword}</b>`);
                  item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(39, 125, 246);font-weight: 500;">${userKeyword}</b>`);
                }
              }
              if(item.classification == -1){
                if(!this.selectedTopic.id || topic.id == this.selectedTopic.id){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
                  item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
                }
              }
              if(item.classification == 0){
                if(!this.selectedTopic.id || topic.id == this.selectedTopic.id){
                  item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
                  item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
                }
              }
            }
            // break;
          }
          if (!item.displayFullContent) {
            item.displayFullContent = item.displayFullContent.slice(0, item.displayFullContent.indexOf("."));
          }
        }
      }
    },
    changeClassificationColorDetail: function(userTopic,item){
      if(item.origin){
        item.displayFullContentOrigin = item.displayFullContent;
        for (let topic of userTopic) {
          for (let keyword of topic.keywords) {
            let userKeyword = keyword.keyword
            let keywordIndex = item.displayFullContent.toLowerCase().indexOf(userKeyword.toLowerCase())
            if (keywordIndex >= 0 ) {
              item.displayFullContent = item.displayFullContent.slice(item.displayFullContent.slice(0, keywordIndex).lastIndexOf(".") + 1);

              if (item.classification == 1) {
                item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(39, 125, 246);font-weight: 500;">${userKeyword}</b>`);
                item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(39, 125, 246);font-weight: 500;">${userKeyword}</b>`);
              }
              if (item.classification == -1) {
                item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
                item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgb(255,0,0);font-weight: 500;">${userKeyword}</b>`);
              }
              if (item.classification == 0) {
                item.displayFullContent = item.displayFullContent.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
                item.displayFullContentOrigin = item.displayFullContentOrigin.replace(new RegExp(userKeyword, "ig"), `<b style = "color: rgba(var(--vs-warning),1);font-weight: 500;">${userKeyword}</b>`);
              }
            }
            // break;
          }
          if (!item.displayFullContent) {
            item.displayFullContent = item.displayFullContent.slice(0, item.displayFullContent.indexOf("."));
          }
        }
      }
    },
    updatePositive:function(item){
      this.item = item;
      item.classification = 1;
      const payload ={
        id:item.id,
        classification: 1
      }
      this.updateClassification(payload);
    },
    updateNegative:function(item){
      this.item = item;
      item.classification =  -1;
      const payload ={
        id:item.id,
        classification: -1
      }
      this.updateClassification(payload);
    },
    updateInter: function(item){
      this.item = item;
      item.classification =0;
      const payload ={
        id:item.id,
        classification: 0
      }
      this.updateClassification(payload);
    },
    updateUndefined: function(item){
      this.item = item;
      item.classification = 2;
      const payload ={
        id:item.id,
        classification: 2
      }
      this.updateClassification(payload);
    },
    copyLink:function(e){
      let link = e.currentTarget.getAttribute('data-url');
      const textArea = document.createElement('textarea');
      textArea.value = link;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("Copy");
      textArea.style.display = "none";
      this.$vs.notify({
        text: this.$t('articleBookmark.textCopy'),
        iconPack: 'feather',
        icon: 'icon-alert',
        color: 'primary'
      })
    },
    isSpam: function () {
      this.$vs.loading();
      let item = this.itemSpam;
      const payload = {
        id: item.id,
      }
      if(item.isBookmark==false){
        this.$processor.post('/user-data/spam', payload).then((response) => {
          this.loadData();
          this.$vs.loading.close();
          return this.$vs.notify({
            text: this.$t('articleBookmark.isSpamSuccess'),
            iconPack: 'feather',
            icon: 'icon-alert',
            color: 'primary'
          })
        }).catch(()=>{
          this.$vs.loading.close();
          return this.$vs.notify({
            text: this.$t('articleBookmark.isSpamUnSuccess'),
            iconPack: 'feather',
            icon: 'icon-alert',
            color: 'danger'
          })
        })
      }else {
        this.$processor.post('/user-data/update-bookmark', payload).then(() => {
          this.$processor.post('/user-data/spam', payload).then(()=>{
            this.loadData();
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.$t('articleBookmark.isSpamSuccess'),
              iconPack: 'feather',
              icon: 'icon-alert',
              color: 'primary'
            })
          }).catch(()=>{
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.$t('articleBookmark.isSpamUnSuccess'),
              iconPack: 'feather',
              icon: 'icon-alert',
              color: 'danger'
            })
          })
        })
      }
    },
    confirmSpam(item){
      this.itemSpam= item;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('articleBookmark.titleTick'),
        text: this.$t('articleBookmark.textTick'),
        accept: this.isSpam,
        acceptText: this.$t('articleBookmark.acceptText'),
        cancelText: this.$t('articleBookmark.cancelText')
      })
    },
    getAllNews: function(){
      this.facePostCheckBox = false;
      this.faceCommentCheckBox = false;
      this.newsPostCheckBox = false;
      this.currentPage = 1;
      this.findAll = true;
      this.$vs.loading();
      this.loadData();
    },
    getAllSocial:function(){
      this.facePostCheckBox = false;
      this.faceCommentCheckBox = false;
      this.newsPostCheckBox = false;
      this.currentPage = 1;
      this.findAll = true;
      this.$vs.loading();
      this.loadData();
    },
    nFormatter:function (num) {
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      return num;
    },

    // Topic-API

    getListTopic:function(){
      const payload ={
      };
      return new Promise((resolve, reject) => {
        this.$business.post('/topic/find-by-conditions',payload).then((response) =>{
          this.$business.post(`share-topic/get-all-share`,  payload).then((res) =>{
            const topicShare = res.data.filter(el => el.status == 1);
            this.optionalsTopic = [...response.data,...topicShare];
            this.userTopics = [...response.data,...topicShare];
            const inputSuggest = this.optionalsTopic;
            this.simpleSuggestionList = inputSuggest;
            if(this.optionalsTopic.length > 0){
              this.optionalsTopic = this.optionalsTopic.map(el =>{
                return {
                  label:el.topicName,
                  value:el.id
                }
              })
              if (this.topicId) {
                let selectedItem = this.optionalsTopic.find(item => item.value == this.topicId)
                if (selectedItem) this.topicSelected = selectedItem;
              }
              this.optionalsTopic.unshift({label: this.$t('articleBookmark.all'),
                value: null})
            }
            resolve()
          })
        })
          .catch(() =>{reject()})
      })

    },
    mouseHover: function(item){
      item.active = true;
    },
    mouseLeave: function(item){
      item.active = false;
    },
    mouseHoverClassification: function(item){
      item.activeClassification = true;
    },
    mouseLeaveClassification:function(item){
      item.activeClassification = false;
    },

    // User-API


    //Topic
    findByTopicId: function(){
      this.$vs.loading();
      this.currentPage = 1;
      this.$vs.loading();
      this.loadData();
    },
    searchByKeyword: function(){
      this.$vs.loading();
      this.loadData()
    },


    //Date-range-picker
    formatDate: function(val){
      return moment(val).format("DD/MM/YYYY");

    },
    dateFormat: function(classes, date){
      if(!classes.disabled){
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    updateValues: function(){
      this.loadData();
      this.$vs.loading.close();

    },
    updateI18n: function(){
      this.valueText = this.$t('articleDetail.newsFeed')
      this.valueTextAll = this.$t('articleDetail.all');
    },
    initScreen: function(){
      this.labelReaction = this.$t('articleDetail.all')
      this.iconFilter = emoji;
      this.valueOldestPost =null;
      this.valueInteractive = null;
      this.classification = null
      this.updateI18n();
      this.valueTextPositive = null;
      this.valueTextNegative = null;
      this.valueInteractiveUp = null;
      this.valueOption = 0;
      if(this.labelSocial){
        this.facePostCheckBox = true;
        this.faceCommentCheckBox = true;
        this.newsPostCheckBox = false;
      }
      if(this.labelNews && !this.facePost && !this.faceComment){
        this.facePostCheckBox = false;
        this.faceCommentCheckBox = false;
        this.newsPostCheckBox = true;
      }
      if(this.newsPostCheckBox && this.facePostCheckBox && this.faceCommentCheckBox && this.youtubeCheckBox && this.forumCheckbox && this.googleCheckbox){
        this.findAll = true;
      }else {
        this.findAll = false;
      }
      if(this.showFacebookProfile == true && this.showFacebookComment == true){
        this.findAll = true;
      }
      if(this.showIgPost == true && this.showIgComment == true){
        this.findAll = true;
      }
      if(this.showNewsPost == true){
        this.findAll = true;
      }
      this.getListTopic().then(()=>{
        // this.getListFacebook();
        if (this.initial) {
          this.loadData();
        }
        this.getDataSource();
      });
      this.getDataSource();
    },
    searchByReaction:function(item){
      this.selectedHaha = null;
      this.selectedAngry = null;
      this.selectedCare = null;
      this.selectedLike = null;
      this.selectedWow = null;
      this.selectedSad = null;
      this.selectedLove = null;
      switch(item.text){
        case 'like':
          this.selectedLike = 1;
          this.labelReaction = this.$t('articleBookmark.like')
          this.iconFilter = item.icon;
          break;
        case 'love':
          this.selectedLove = 1;
          this.labelReaction =  this.$t('articleBookmark.love')
          this.iconFilter = item.icon;
          break;
        case 'haha':
          this.selectedHaha =1;
          this.labelReaction = 'Haha';
          this.iconFilter = item.icon;
          break;
        case 'sad':
          this.selectedSad =1;
          this.labelReaction =  this.$t('articleBookmark.sad')
          this.iconFilter = item.icon;
          break;
        case 'wow':
          this.selectedWow =1;
          this.labelReaction =  this.$t('articleBookmark.wow')
          this.iconFilter = item.icon;
          break;
        case 'care':
          this.selectedCare = 1;
          this.labelReaction =  this.$t('articleBookmark.care')
          this.iconFilter = item.icon;
          break;
        case 'angry':
          this.selectedAngry =1;
          this.labelReaction =  this.$t('articleBookmark.angry')
          this.iconFilter = item.icon;
          break;
        case 'all':
          this.labelReaction =  this.$t('articleBookmark.all')
          this.iconFilter = item.icon;
          this.selectedLike = null;
          this.selectedLove = null;
          this.selectedHaha = null;
          this.selectedSad = null;
          this.selectedWow = null;
          this.selectedCare = null;
          this.selectedAngry = null;
          break;
      }
      this.currentPage = 1;
      this.$vs.loading();
      this.loadData();
    },
    updateBookmark: function(item){
      this.$vs.loading();
      const payload ={
        id: item.id
      }
      this.$processor.post('/user-data/update-bookmark',payload).then(() =>{
        this.checkBookmark = false;
        this.loadData();
        this.formData.isBookmark=!this.formData.isBookmark;
        this.$vs.loading.close();
        this.$vs.notify({
          text: this.$t('articleBookmark.textSave'),
          iconPack: 'feather',
          icon: 'icon-alert',
          color: 'primary'
        })
      }).catch(()=>{
        this.checkBookmark = false;
        this.loadData();
        this.$vs.loading.close();
        if(this.formData.isBookmark || item.isBookmark){
          this.$vs.notify({
            text: this.$t('articleBookmark.textUnsave'),
            iconPack: 'feather',
            icon: 'icon-alert',
            color: 'danger'
          })
        }
        if(!this.formData.isBookmark || !item.isBookmark){
          {
            this.$vs.notify({
              text: this.$t('articleBookmark.seveNotDone'),
              iconPack: 'feather',
              icon: 'icon-alert',
              color: 'danger'
            })
          }
        }
      })
    },
    exportFile: function (){

      this.$vs.loading();
      let payload ={
        pageNumber: this.pageNumber,
        pageSize:10,
        userDataElasticsearch:{classification: this.classification, topicId: this.topicName ? this.topicName : null, isBookmark:true,isSpam: false},
        recently: this.valueText,
        oldestPost: this.valueOldestPost,
        interactive:this.valueInteractive,
        interactiveAscending: this.valueInteractiveUp,
        newsPost: this.newsPostCheckBox ? 101:0,
        facePost: this.facePostCheckBox ? 104: 0,
        faceComment: this.faceCommentCheckBox ? 105:0,
        igPost: this.faceCommentCheckBox ? 119:0,
        igComment: this.faceCommentCheckBox ? 120:0,
        youtube:this.youtubeCheckBox ? 106 : 0,
        youtubeComment:this.youtubeCheckBox ? 107 : 0,
        forum: this.forumCheckbox ? 111 : 0,
        forumComment:this.forumCheckbox ? 112 : 0,
        google: this.googleCheckbox ? 113 : 0,
        tiktok : this.tiktokCheckbox ? 116: 0,
        tiktokTrending : this.tiktokCheckbox ? 117: 0,
        twitter : this.twitterCheckbox ? 118: 0,
        fromDate: this.dateRange.startDate,
        toDate: this.dateRange.endDate,
        content: this.formData.keyword,
        hahaCount: this.selectedHaha,
        likeCount: this.selectedLike,
        loveCount: this.selectedLove,
        sadCount: this.selectedSad,
        wowCount: this.selectedWow,
        careCount: this.selectedCare,
        angryCount: this.selectedAngry
      }

      if (!payload.newsPost && !payload.facePost && !payload.faceComment && !payload.igPost && !payload.igComment && !payload.youtube && !payload.youtubeComment && !payload.forum && !payload.forumComment && !payload.google) {
        if (this.showFacebookProfile != "false") payload.facePost = 104
        if (this.showFacebookComment != "false") payload.faceComment = 105
        if (this.showNewsPost != "false") payload.newsPost = 101
        if(this.showYoutube != 'false') {payload.youtube  = 106; payload.youtubeComment = 107}
        if(this.showForum != 'false') {payload.forum = 111; payload.forumComment  = 112}
        if(this.showGoogle != false) payload.google =  113
        if(this.showTiktok != 'false') {payload.tiktok  = 116; payload.tiktokTrending = 117}
        if(this.showTwitter != 'false') payload.twitter =  118
        if(this.showIgPost != 'false') payload.igPost =  119
        if(this.showIgComment != 'false') payload.igComment =  120
      }

      this.$report.post('/user-data/export-word-priority',payload).then(response =>{
        this.$vs.loading.close();
        if (!response || !response.data) return this.$vs.notify({
          text: this.$t('createReportError'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
        window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
        return this.$vs.notify({
          text: this.$t('articleBookmark.textDlData'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      }).catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
    }
  },
  async created(){
    this.dateRange.startDate = new Date(
      this.dateRange.startDate.setHours(0, 0, 0)
    );
    this.dateRange.endDate = new Date(
      this.dateRange.endDate.setHours(23, 59, 59)
    );
    this.initScreen()
    this.$eventBus.$on('i18n', (event) =>{
      this.initScreen();
    })
  },
  mounted(){
    let screen = window.screen.height;
    if (screen >= 1080){
      this.resizeContent = '800px'
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/vxCard.scss";
#demo-basic-card{
  .card-view-new {
    background: #fff;
    border-radius: 10px;
    padding: 0px 10px 10px 10px;
    box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 0.1);
    -webkit-transition: all 0.3s ease-in-out;
  }
}
.card-preview{
  background-color:rgba(0, 122, 254, 0.06);
  padding: 8px 24px;
  border-radius: 5px
}
.hide-text-source{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 160px;
}
</style>
<style lang="css">
.custom-time .reportrange-text{
  white-space: nowrap;
  min-width: fit-content;
}
.style-header-form{
  display: flex;
  align-items: center;
  border-radius: 0px 10px 0px 0px;
}
.text-spam{
  white-space: nowrap;
}
.feather-drop {
  width: 15px;
  vertical-align: middle;
}
</style>
